export const MAIN_PAGE_PADDING = '4rem';

export const BREAKPOINTS = {
  xs: 640,
  sm: 768,
  md: 1024,
  lg: 1440,
  xl: 1920,
  xxl: 2560
} as const;

export type Breakpoint = keyof typeof BREAKPOINTS;

export const remSizes = {
  small: 1,
  medium: 1.1,
  large: 1.2
};
